import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { authService } from "@/lib/api";
import { useAuthStore } from "@/stores/auth";
import { useQuery } from "@tanstack/react-query";
import { Outlet } from "react-router-dom";
import { AdminShell } from "./AdminShell";

/** Auth gate + admin chrome wrapper for all /admin/* routes. */
export function ProtectedAdminLayout() {
  const token = useAuthStore((s) => s.token);
  const setUser = useAuthStore((s) => s.setUser);

  // Hydrate the current operator once a token exists (e.g. after refresh).
  useQuery({
    queryKey: ["auth-me"],
    queryFn: async () => {
      const me = await authService.me();
      setUser(me);
      return me;
    },
    enabled: Boolean(token),
    staleTime: 1000 * 60 * 10,
  });

  return (
    <ProtectedRoute>
      <AdminShell>
        <Outlet />
      </AdminShell>
    </ProtectedRoute>
  );
}
